import { escapeICS } from "./utils";
export function proposeSlots({ count = 3, durationMin = 15 }) {
  const slots = [];
  const now = new Date();
  let d = new Date(now.getTime());
  d.setHours(9, 30, 0, 0);
  if (now.getHours() >= 16) d.setDate(d.getDate() + 1);
  while (slots.length < count) {
    if (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
      d.setHours(9, 30, 0, 0);
      continue;
    }
    const hours = [9, 14, 16];
    const mins = [30, 0, 0];
    for (let i = 0; i < hours.length && slots.length < count; i++) {
      const slot = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        hours[i],
        mins[i],
        0,
        0
      );
      if (slot > now) slots.push(slot);
    }
    d.setDate(d.getDate() + 1);
  }
  return slots;
}
export function googleCalendarLink({ title, desc, start, end }) {
  const fmt = (d) =>
    d
      .toISOString()
      .replace(/[-:]/g, "")
      .replace(/\.\d{3}Z$/, "Z");
  const details = encodeURIComponent(desc);
  const text = encodeURIComponent(title);
  const dates = `${fmt(start)}/${fmt(end)}`;
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&details=${details}&dates=${dates}`;
}
export function icsBlob({ title, desc, start, end }) {
  const pad = (n) => String(n).padStart(2, "0");
  const toICSDate = (d) =>
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(
      d.getUTCDate()
    )}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(
      d.getUTCSeconds()
    )}Z`;
  const uid = `bossdrop-${Date.now()}@local`;
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//BossDrop//MVP//EN",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${toICSDate(new Date())}`,
    `DTSTART:${toICSDate(start)}`,
    `DTEND:${toICSDate(end)}`,
    `SUMMARY:${escapeICS(title)}`,
    `DESCRIPTION:${escapeICS(desc)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar" });
  return URL.createObjectURL(blob);
}

export default googleCalendarLink;
